import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { GoodDetailMinPrice } from '@/src/pages/shop/c_shop/component';
import { SOURCE_MULTI_SKU_NUM } from '@/components/MultiSkuModal/constant';
import { reportCodeTryException } from '@/src/common/exception';
import getCurrencySymbol from '../../../../utils/getCurrencySymbol';

interface IProps {
  totalPrice: { //价格对象
    originPrice: GoodDetailMinPrice;
    discountPrice: GoodDetailMinPrice;
    currency: string;
  };
  ready: boolean;
  clickAddBtn: VoidFunction;
  btnText?: string;
  showPrice: boolean;
  source?: number;

  lxClickMv: VoidFunction;
}

class SubmitBtn extends React.Component<any> {
  shouldComponentUpdate(nextProps: Readonly<IProps>): boolean {
    if (this.props.totalPrice !== nextProps.totalPrice || this.props.ready !== nextProps.ready) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <view>
        {this.renderBtn()}
      </view>
    );
  }

  // 渲染结算按钮
  renderBtn = () => {
    const { source } = this.props;
    if (source === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW || source === SOURCE_MULTI_SKU_NUM.SHOP_CART_POPUP) {
      return this._renderNormalBtn();
    } else {
      // 一口价、919活动落地页，其它活动类型落地页
      return this._renderFixedPriceBtn();
    }
  }

  _renderNormalBtn = () => {
    const {
      totalPrice, ready, clickAddBtn, btnText, showPrice,
    } = this.props;
    const color = ready ? '#222222' : '#FFFFFF80';
    const showOrigin = totalPrice.originPrice.amount > totalPrice.discountPrice?.amount;
    return (
      <view
        className="add-food-btn"
        style={{ backgroundColor: ready ? '#FFEA00' : '#CACACA' }}
        onClick={clickAddBtn}
      >
        <text
          className="add-btn-text"
          style={{ color }}
          content={btnText}
        />
        {showPrice && (
          <view style={{ height: 22 }}>
            <text
              className="add-btn-price-text"
              style={{ color }}
              content={totalPrice.discountPrice?.displayText}
            />
            {showOrigin && (
              <text
                className="add-btn-origin-price-text"
                style={{ color: ready ? '#22222280' : '#FFFFFF80' }}
                content={totalPrice.originPrice.displayText}
              />
            ) }
          </view>
        )}
      </view>
    );
  }

  _renderFixedPriceBtn = () => {
    const {
      totalPrice, ready, clickAddBtn, t, source, lxClickMv
    } = this.props;
    const displayOriginAmount = totalPrice.originPrice.displayText;
    const orderText = source === SOURCE_MULTI_SKU_NUM.FIXED_PRICE ? t('fixprice_cart_2')
      : source === SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE ? t('mkt_promo_guigecheckoutbutton')
        : t('landingpage_guige_checkout_button');
    const { displayText } = totalPrice.discountPrice;
    const richText = displayText ? this.getPriceRichText(totalPrice.discountPrice) : undefined;
    const leftWidth = Mach.env.screenWidth - 170;
    const showOrigin = totalPrice.originPrice.amount > totalPrice.discountPrice?.amount;

    // 曝光
    if (lxClickMv) {
      lxClickMv();
    }

    return (
      <view
        className="add-food-btn-fixed"
      >
        <view className="fixed-price-left-part-view" style={{ width: leftWidth, backgroundColor: '#222222' }}>
          <view className="left-price-part">
            {richText && <rich-text className="richtext_price" content={richText} />}
            {showOrigin
                            && <text className="fixed-price-origin-price" content={`${displayOriginAmount}`} />}
          </view>
        </view>
        <view className="fixed-price-right-part-view" style={{ backgroundColor: ready ? '#FFEA00' : '#CACACA' }} onClick={clickAddBtn}>
          <text
            style={{ color: ready ? '#222222' : '#FFFFFF80' }}
            className="fixed-price-btn-text"
            content={orderText}
          />
        </view>
      </view>
    );
  }

  getPriceRichText = (price: any) => {
    if (!price) return [];
    const { displayAmount, currency, currencySign } = price;
    let currencyText = getCurrencySymbol({ currency });
    if (currencySign) {
      currencyText = currencySign;
    }
    try {
      const amountArr = displayAmount.split('.') || [];
      const integer = amountArr?.[0];
      const decimal = amountArr?.[1] || '00';
      const richText = [
        {
          type: 'text',
          text: currencyText,
          color: '#FFFFFF',
          fontSize: 14,
          fontFamily: 'KeeTa-Bold',
          fontWeight: 700,
        },
        {
          type: 'text',
          text: integer,
          color: '#FFFFFF',
          fontSize: 28,
          fontFamily: 'KeeTa-Bold',
          fontWeight: 700,
        },
        {
          type: 'text',
          text: `.${decimal}`,
          color: '#FFFFFF',
          fontSize: 14,
          fontWeight: 700,
          fontFamily: 'KeeTa-Bold',
        }
      ];
      return richText;
    } catch (error) {
      console.log('[getPriceRichText error]:', error);
      // 捕获到异常上报
      reportCodeTryException({
        message: 'getPriceRich',
        extra: error
      });
      return [];
    }
  };
}

export default withTranslation('', {
  withRef: true,
})(SubmitBtn);
